import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import arrowUp from '@icons/arrow-up.png';

import ButtonBase from '@mui/material/ButtonBase';

import styles from './style.scss';

export const ScrollUpButton = () => {
  const [scrollY, setScrollY] = useState(0);
  const [documentHeight, setDocumentHeight] = useState(600);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setDocumentHeight(document.documentElement.scrollHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <ButtonBase className={classNames(styles.scrollUpButton, scrollY > documentHeight && styles.show)} onClick={handleClick}>
      <img src={arrowUp} alt="scroll-up" className={styles.icon} />
    </ButtonBase>
  );
};
